module.exports = __webpack_public_path__ + "static/member_04-ea0ad17033e63b5b5e15726e8031659c.jpg";